<template>
	<div>
		<el-form ref="elForm" :model="formData" :rules="rules" size="small" label-width="130px">
			<el-form-item label="设备类型" prop="deviceType">
				<el-input v-model="formData.deviceType" placeholder="请输入设备类型" clearable :style="{ width: '100%' }"></el-input>
			</el-form-item>
			<el-form-item label="父级">
				<el-select v-model="formData.pid" placeholder="请选择父级" class="select-item">
					<el-option v-for="(item, index) in deviceTypeData" :key="index" :label="item.deviceType" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<div style="text-align: right">
					<span class="dialog-footer">
						<el-button @click="formCancel">取 消</el-button>
						<el-button type="primary" @click="formSubmit">确 定</el-button>
					</span>
				</div>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { deviceTypeAddService, deviceTypeEditService, deviceTypeListService } from '@s/base/DeviceTypeService';
import { deleteTreeNodeById } from '@u/htools.tree';

export default {
	components: {},
	props: ['selectData_p', 'isRefreshList_p'],
	data() {
		return {
			editId: -1,
			formData: {
				deviceType: ''
			},
			rules: {
				name: [
					{
						required: true,
						message: '请输入设备类型',
						trigger: 'blur'
					}
				]
			},
			deviceTypeData: null
		};
	},
	computed: {},
	watch: {
		selectData_p: {
			async handler(newValue) {
				this.deviceTypeData === null && (await this.deviceTypeList());
				if (newValue.length > 0) {
					this.editId = newValue[0].id;

					this.formData = { ...newValue[0] };
				}
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		async deviceTypeList() {
			const dataJson = {
				pageNum: 1,
				pageSize: 100000,
				type: 0
			};
			const res = await deviceTypeListService(dataJson);
			if (this.editId === -1) {
				this.deviceTypeData = [...res.records];
			} else {
				this.deviceTypeData = deleteTreeNodeById(res, this.editId, 'id');
			}
		},
		formSubmit() {
			this.$refs.elForm.validate(async valid => {
				if (valid) {
					if (this.editId === -1) {
						await deviceTypeAddService(this.formData);
						this.$emit('update:isRefreshList_p', true);
					} else {
						const dataJson = {
							id: this.editId,
							...this.formData
						};
						await deviceTypeEditService(dataJson);
						this.$emit('update:isRefreshList_p', true);
					}
					this.formCancel();
				} else {
					this.$emit('update:isRefreshList_p', false);
				}
			});
		},
		formCancel() {
			this.$emit('update:isShowAEDialog_p', false);
		}
	}
};
</script>
<style>
</style>
